import React from 'react'
import { SvgIcon } from '@mui/material'

export const RemovePersonIcon = props => (
  <SvgIcon viewBox="0 0 32 32" {...props}>
    <path
      fill="#fff"
      d="M13.333 5.333a5.333 5.333 0 1 0 0 10.667 5.333 5.333 0 0 0 0-10.667Zm10 12c-3.333 0-6 2.667-6 6 0 3.334 2.667 6 6 6 3.334 0 6-2.666 6-6 0-3.333-2.666-6-6-6Zm-10 1.334C7.44 18.667 2.667 21.053 2.667 24v2.667h12.666a8.666 8.666 0 0 1-.666-3.334 8.666 8.666 0 0 1 1.266-4.48 20.403 20.403 0 0 0-2.6-.186Zm10 .666c2.214 0 4 1.787 4 4 0 .747-.2 1.44-.56 2l-5.44-5.44c.56-.36 1.254-.56 2-.56Zm-3.44 2 5.44 5.44c-.56.36-1.253.56-2 .56-2.213 0-4-1.786-4-4 0-.746.2-1.44.56-2Z"
    />
  </SvgIcon>
)
